module.exports = __webpack_public_path__ + "static/media/iconNoticia.ce343fc8.svg";